import produce from 'immer';
import { handleActions } from 'redux-actions';
import { transferToQueueActions } from '../actions/transferToQueueModal';
const initialState = {
    meta: {
        asyncStatus: 'succeeded',
    },
    ui: {
        isModalShown: false,
    },
    csid: null,
    requests: [],
};
export const { transferToQueueModalOpen, transferToQueueModalClose, transferToQueueModalRequest, transferToQueueModalRequestSucceeded, transferToQueueModalRequestFailed, transferToQueueModalRequestStop, transferToQueueWsResponse, transferToQueueWsTransferStarted, transferToQueueWsTransferAnswered, } = transferToQueueActions;
export const transferToQueue = handleActions({
    [transferToQueueModalOpen.toString()]: (state, action) => {
        return produce(state, (draft) => {
            draft.ui.isModalShown = true;
            draft.csid = action.payload.csid;
        });
    },
    [transferToQueueModalClose.toString()]: (state) => {
        return produce(state, (draft) => {
            draft.ui.isModalShown = false;
            draft.csid = null;
        });
    },
    [transferToQueueModalRequest.toString()]: (state, action) => {
        const { csid, requestToQueue } = action.payload;
        return produce(state, (draft) => {
            draft.meta.asyncStatus = 'loading';
            draft.requests = [
                ...draft.requests.filter((request) => request.csid !== csid),
                { csid, requestToQueue, timeout: 3100 },
            ];
        });
    },
    [transferToQueueModalRequestSucceeded.toString()]: (state, action) => {
        const { csid } = action.payload.meta.request;
        const index = state.requests.findIndex((request) => request.csid === csid);
        return produce(state, (draft) => {
            draft.meta.asyncStatus = 'succeeded';
            if (index > -1) {
                draft.requests = draft.requests.filter((request) => request.csid !== csid);
            }
        });
    },
    [transferToQueueModalRequestFailed.toString()]: (state, action) => {
        const { csid } = action.payload;
        const index = state.requests.findIndex((request) => request.csid === csid);
        return produce(state, (draft) => {
            if (index > -1) {
                draft.meta.asyncStatus = 'failed';
                draft.requests = draft.requests.filter((request) => request.csid !== csid);
            }
        });
    },
    [transferToQueueModalRequestStop.toString()]: (state, action) => {
        const { csid } = action.payload;
        const index = state.requests.findIndex((request) => request.csid === csid);
        return produce(state, (draft) => {
            if (index > -1) {
                draft.meta.asyncStatus = 'failed';
                draft.requests = draft.requests.filter((request) => request.csid !== csid);
            }
        });
    },
    [transferToQueueWsResponse.toString()]: (state, action) => {
        const { csid, accepted } = action.payload;
        const index = state.requests.findIndex((request) => request.csid === csid && (accepted === true || accepted === false));
        return produce(state, (draft) => {
            if (index > -1) {
                draft.requests = draft.requests.filter((request) => request.csid !== csid);
            }
        });
    },
}, initialState);
